export const TEXT_POSITION = Object.freeze({
	TOP: 'top',
	BOTTOM: 'bottom',
})

export const CONTENT_DIRECTION = Object.freeze({
	top: 'desc',
	bottom: 'asc',
})
